import React, { FC } from 'react';
import { AnalyticsSenderProvider, parseAutoOpenWidgetParams } from '@funtech-int/yango-shared';

import { useHasSubscription } from '@/shared/hooks/useHasSubscription';
import { clientOnlyPage } from '@/shared/lib/clientOnly';
// TODO: отказаться от прямого импорта когда перейдем на @/scenarios/player https://st.yandex-team.ru/SAFT-8848
import { PlayerManager } from '@/scenarios/legacy-player/components/PlayerManager/PlayerManagerMain';
import { RememberedPages, useRemeberPage } from '@/shared/hooks/userRememberPage';
import { AutoOpenPaymentWidget } from '@/shared/components/AutoOpenPaymentWidget/AutoOpenPaymentWidget';
import { useSearchParams } from '@/shared/hooks/useSearchParams';

import { CounterOfferOnHome } from '../CounterOffer/CounterOfferOnHome';
import { useMultiOfferSuccessPurchase } from '../../hooks/useMultiOfferSuccessPurchase';

import { HomeComponent } from './HomeComponent';
import { MainPageHead } from './PageHead';

const HomeContent = clientOnlyPage(() => {
    useRemeberPage(RememberedPages.Main);

    const hasSubscription = useHasSubscription();

    const searchParams = useSearchParams();
    const offerParams = parseAutoOpenWidgetParams(searchParams.toString());

    const onSuccessPurchase = useMultiOfferSuccessPurchase({
        billingFeatureNames: [offerParams?.billingFeatureName ?? ''],
    });

    return (
        <>
            <PlayerManager />
            <AnalyticsSenderProvider>
                <HomeComponent hasSubscription={hasSubscription} />
                <AutoOpenPaymentWidget onSuccessPurchase={onSuccessPurchase} />
                <CounterOfferOnHome />
            </AnalyticsSenderProvider>
        </>
    );
});

export const Home: FC = () => (
    <>
        <MainPageHead />
        <HomeContent />
    </>
);

export default Home;
